export function getAlphanumericString(s: string): string {
	return s.replace(/[^a-zA-Z0-9]/g, '');
}

export function sortCsv(csv: string): string {
	let values = csv.split(',');
	values.sort();
	return values.join(',');
}


// WEBPACK FOOTER //
// src/helpers/stringHelper.ts